<template>
  <div class="little-header">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang='less'>
.little-header {
  line-height: 40px;
  width: 100%;
  color: white;
  padding: 0 10px;
  background-color: #3b4348;
}
</style>